import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
import Container from 'reactstrap/lib/Container';

import { connect } from 'react-redux';

import { setProfileOptions } from 'client/actions/profile';

import './welcome-text.scss';

const FEATURES = [
  'Get price & inventory alerts',
  'Manage your saved cars & searches',
  'Access personalized shopping tools & tips',
];

function WelcomeTextUI({ idmData = null, isMobile, closeWelcomeDrawer, isWelcomeDrawerClosed = false }) {
  const lastLandingPageVisitTs = get(idmData, 'intelligentMessaging.lastLandingPageVisitTs', '');
  const vins = Object.keys(get(idmData, 'vehicles.vins', {}));
  const savedSearches = get(idmData, 'savedSearches', []);
  const showWelcome =
    idmData !== null &&
    !isWelcomeDrawerClosed &&
    isMobile &&
    (!lastLandingPageVisitTs || (!vins.length && !savedSearches.length));

  if (!showWelcome) {
    return null;
  }

  return (
    <Container className="mt-3_5 mb-1 px-0">
      <div className="welcome-text pos-r bg-gray-extra-light rounded px-1_5 pt-3_5 pb-0_5">
        <span className="icon-bell-container rounded-circle text-primary bg-white p-1_25">
          <i className="icon-bell3" aria-hidden />
        </span>
        <Button className="btn-close" aria-label="Close" onClick={closeWelcomeDrawer}>
          <i className="icon-cross2 text-white small rounded p-0_25" aria-hidden />
        </Button>
        <ul className="list-unstyled fw-medium mt-0_5 mb-0 p-0">
          {FEATURES.map(feature => (
            <li className="pb-1 d-flex align-items-center" key={feature}>
              <i className="icon-checkmark pe-1" aria-hidden />
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </Container>
  );
}

WelcomeTextUI.propTypes = {
  idmData: PropTypes.shape({
    lastLandingPageVisitTs: PropTypes.string,
    savedSearches: PropTypes.array,
    vehicles: PropTypes.shape({
      vins: PropTypes.shape({}),
    }),
  }),
  isMobile: PropTypes.bool.isRequired,
  closeWelcomeDrawer: PropTypes.func.isRequired,
  isWelcomeDrawerClosed: PropTypes.bool,
};

export const mapStateToProps = state => ({
  idmData: get(state, 'profile.data.idm'),
  isWelcomeDrawerClosed: get(state, 'profile.options.isWelcomeDrawerClosed'),
});

export const mapDispatchToProps = dispatch => ({
  closeWelcomeDrawer: () => dispatch(setProfileOptions({ isWelcomeDrawerClosed: true })),
});

export const WelcomeText = connect(mapStateToProps, mapDispatchToProps)(WelcomeTextUI);
